export const ACTION_GET_PROFILE = 'ACTION_GET_PROFILE'
export const ACTION_SAVE_PROFILE = 'ACTION_SAVE_PROFILE'

export const SET_PROFILE = 'SET_PROFILE'
export const SET_NICKNAME = 'SET_NICKNAME'
export const RESET_PROFILE_STATE = 'RESET_PROFILE_STATE'

export const PROFILE_KEY = 'profile'
export const NICKNAME_KEY = 'nickname'
